import { ReactNode } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

export type KpiAccent = "text-theme-info" | "text-theme-success" | "text-theme-warning" | "text-theme-danger";

export const KpiChip = ({ icon, label, value, unit, accent = "text-theme-info", note }: { icon: IconDefinition; label: string; value: ReactNode; unit?: string; accent?: KpiAccent; note?: ReactNode }) => (
  <div className="min-h-[70px] flex items-center justify-center sm:justify-start gap-3 px-4 py-3 sm:rounded-lg border-y sm:border-x border-theme-border bg-theme-surface-2 shadow-sm shadow-theme-shadow hover:shadow-md transition-all">
    <div className={`flex items-center justify-center w-10 h-10 rounded-full bg-theme-surface shrink-0 ${accent}`}>
      <FontAwesomeIcon icon={icon} className="text-lg" />
    </div>
    <div className="flex flex-col min-w-0">
      <span className="text-xs md:text-sm text-theme-text-muted uppercase tracking-wide truncate">{label}</span>
      <span className="text-lg md:text-xl font-semibold text-theme-text leading-tight truncate animate-fade-in">
        {value}{unit && <span className="text-sm font-normal text-theme-text-muted ml-1">{unit}</span>}
      </span>
      {note && <span className="text-xs text-theme-text-muted truncate">{note}</span>}
    </div>
  </div>
);

export type PillTone = "success" | "warning" | "danger" | "info" | "neutral" | "muted";

const PILL_TONES: Record<PillTone, string> = {
  success: "bg-theme-success text-white",
  warning: "bg-theme-warning text-white",
  danger: "bg-theme-danger text-white",
  info: "bg-theme-info text-white",
  neutral: "bg-theme-surface text-theme-text border border-theme-border",
  muted: "bg-theme-text-muted text-white",
};

export const Pill = ({ tone, children }: { tone: PillTone; children: ReactNode }) => (
  <span className={`text-xs px-2 py-0.5 rounded-full font-bold leading-none inline-flex items-center gap-1 whitespace-nowrap ${PILL_TONES[tone]}`}>{children}</span>
);
